exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo[data-v-7127db39] {\r\n  max-height: 250px;\r\n  max-width: 250px;\r\n  margin-bottom: 20px;\n}\n.wrapper[data-v-7127db39] {\r\n  margin-top: -25px;\n}\r\n\r\n", ""]);

// exports
